import Card from './card'
import Edit from './edit'
import New from './new'

const card = {
  code: 'advisor_start',
  card: Card,
  edit: Edit,
  new: New,
  editable: false
}

export default card
